// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_product_type = /** @type {(inputs: {}) => string} */ () => {
	return `Type`
};

const el_product_type = /** @type {(inputs: {}) => string} */ () => {
	return `Τύπος`
};

const ru_product_type = /** @type {(inputs: {}) => string} */ () => {
	return `Тип`
};

const he_product_type = /** @type {(inputs: {}) => string} */ () => {
	return `סוג`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const product_type = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.product_type(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("product_type", locale)
	if (locale === "en") return en_product_type(inputs)
	if (locale === "el") return el_product_type(inputs)
	if (locale === "ru") return ru_product_type(inputs)
	if (locale === "he") return he_product_type(inputs)
	return "product_type"
};